module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "dialog-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "el-dialog-wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.handleWrapperClick($event)
      }
    }
  }, [_c('div', {
    ref: "dialog",
    staticClass: "el-dialog",
    class: [_vm.sizeClass, _vm.customClass],
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "el-dialog-header"
  }, [_c('span', {
    staticClass: "el-dialog-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "el-dialog-headerbtn"
  }, [(_vm.showClose) ? _c('i', {
    staticClass: "el-dialog-close el-icon el-icon-close",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.rendered) ? _c('div', {
    staticClass: "el-dialog-body"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "el-dialog-footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23fcd453!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/src/dialog.vue
// module id = 624
// module chunks = 0